import { API } from '@/api';

export async function fetchShopProduct() {
  const { results } = await API.Shop.fetchShopProducts();
  return results[0] || null;
}
